/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AllowedDenied,
    AllowedDeniedFromJSON,
    AllowedDeniedFromJSONTyped,
    AllowedDeniedToJSON,
} from './';

/**
 * 
 * @export
 * @interface AllowedDeniedIdAndLabel
 */
export interface AllowedDeniedIdAndLabel {
    /**
     * 
     * @type {AllowedDenied}
     * @memberof AllowedDeniedIdAndLabel
     */
    id?: AllowedDenied;
    /**
     * 
     * @type {string}
     * @memberof AllowedDeniedIdAndLabel
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedDeniedIdAndLabel
     */
    effective?: boolean;
}

export function AllowedDeniedIdAndLabelFromJSON(json: any): AllowedDeniedIdAndLabel {
    return AllowedDeniedIdAndLabelFromJSONTyped(json, false);
}

export function AllowedDeniedIdAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllowedDeniedIdAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : AllowedDeniedFromJSON(json['id']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function AllowedDeniedIdAndLabelToJSON(value?: AllowedDeniedIdAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': AllowedDeniedToJSON(value.id),
        'label': value.label,
        'effective': value.effective,
    };
}


